<script>
    // Based on https://github.com/pal03377/svelte-sortablejs

	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

    import Sortable from 'sortablejs/modular/sortable.core.esm.js';

    export let items = [];
    export let idKey = "id";
    export let ulClass = "";
    export let liClass = "";

    let sortable;
    let listElement;
    $: if(listElement && !sortable) {
        sortable = Sortable.create(listElement, {
            onEnd: (evt) => {
                dispatch("end", evt)
            }
        });
    }
</script>

<ul bind:this={ listElement } class={ ulClass }>
    {#each items as item (item[idKey])}

	<li class={ (typeof liClass === "function") ? liClass(item) : liClass } data-id={ item[idKey] }>
        <slot { item }>{ item }</slot>
    </li>

    {/each}
</ul>